export default __webpack_public_path__ + "static/media/scale.68df71a5.svg";